import React from "react";
import { NavLink } from "react-router-dom";
import "./BottomNav.css";

const BottomNav = () => {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" end className="nav-item">
        <span className="nav-icon">🏠</span>
        <span className="nav-label">Anasayfa</span>
      </NavLink>
      <NavLink to="/scan" className="nav-item">
        <span className="nav-icon">📸</span>
        <span className="nav-label">Tara</span>
      </NavLink>
      <NavLink to="/select-products" className="nav-item">
        <span className="nav-icon">⚖️</span>
        <span className="nav-label">Karşılaştır</span>
      </NavLink>
      <NavLink to="/personalize" className="nav-item">
        <span className="nav-icon">🪞</span>
        <span className="nav-label">Beni Keşfet</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
